import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { When } from 'react-if';
import { useModal } from '@ebay/nice-modal-react';
import { Dialog, DialogContent, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { cn } from '@zep/utils';
import { useScrollRestoration } from '../hooks';
import { MapTemplateFooterBanner } from './footer-banner/MapTemplateFooterBanner';
import S from './MapTemplateModal.module.scss';
import { MapTemplateModalHeader } from './MapTemplateModalHeader';
import { MapTemplatesProps, OfficialMapTemplates, PurchasedMapTemplates } from './MapTemplates';
export const MapTemplateModal = (props: MapTemplateModalProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    initialState,
    onStateChange,
    onSelectTemplate
  } = props;
  const {
    visible,
    hide,
    remove
  } = useModal();
  const [type, setType] = useState<'official' | 'purchased'>(initialState.filterType);
  const [categoryId, setCategoryId] = useState(initialState.filterCategoryId);
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  useScrollRestoration({
    scrollRef: contentRef,
    isActive: visible,
    initialPosition: initialState.scrollPosition,
    onScrollChange: position => {
      onStateChange({
        scrollPosition: position
      });
    }
  });
  const handleCategoryChange = (newCategoryId: number) => {
    setCategoryId(newCategoryId);
    onStateChange({
      filterCategoryId: newCategoryId
    });
    contentRef.current?.scrollTo(0, 0);
  };
  return <Dialog maxWidth="968px" open={visible} onClose={hide} afterClose={remove} drawer data-sentry-element="Dialog" data-sentry-component="MapTemplateModal" data-sentry-source-file="MapTemplateModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="MapTemplateModal.tsx" />
      <DialogPanel className={S.wrapper} data-sentry-element="DialogPanel" data-sentry-source-file="MapTemplateModal.tsx">
        <DialogHeader onClose={hide} className="z-[60] bg-white" data-sentry-element="DialogHeader" data-sentry-source-file="MapTemplateModal.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="MapTemplateModal.tsx">{t('common:createSpace.header')}</DialogTitle>
        </DialogHeader>
        <MapTemplateModalHeader tab={type} onTabChange={newType => {
        setType(newType);
        onStateChange({
          filterType: newType
        });
      }} categoryId={categoryId} onCategoryChange={handleCategoryChange} isDropdownOpen={isCategoryDropdownOpen} onDropdownOpenChange={setIsCategoryDropdownOpen} data-sentry-element="MapTemplateModalHeader" data-sentry-source-file="MapTemplateModal.tsx" />
        <DialogContent ref={contentRef} id="template_modal_content" className={cn('relative', S.customDialogContent)} data-sentry-element="DialogContent" data-sentry-source-file="MapTemplateModal.tsx">
          {isCategoryDropdownOpen && <div className="absolute inset-0 z-40 bg-black/30" onClick={() => setIsCategoryDropdownOpen(false)} />}
          <When condition={type === 'official'} data-sentry-element="When" data-sentry-source-file="MapTemplateModal.tsx">
            <OfficialMapTemplates categoryId={categoryId} onSelectTemplate={onSelectTemplate} data-sentry-element="OfficialMapTemplates" data-sentry-source-file="MapTemplateModal.tsx" />
          </When>
          <When condition={type === 'purchased'} data-sentry-element="When" data-sentry-source-file="MapTemplateModal.tsx">
            <PurchasedMapTemplates onSelectTemplate={onSelectTemplate} data-sentry-element="PurchasedMapTemplates" data-sentry-source-file="MapTemplateModal.tsx" />
          </When>
        </DialogContent>
        <MapTemplateFooterBanner data-sentry-element="MapTemplateFooterBanner" data-sentry-source-file="MapTemplateModal.tsx" />
      </DialogPanel>
    </Dialog>;
};
export type MapTemplateModalProps = Pick<MapTemplatesProps, 'onSelectTemplate'> & {
  initialState: {
    filterType: 'official' | 'purchased';
    filterCategoryId: number;
    scrollPosition: number;
  };
  onStateChange: (updates: {
    filterType?: 'official' | 'purchased';
    filterCategoryId?: number;
    scrollPosition?: number;
  }) => void;
};